




































import Vue from 'vue';
import { CalculatorButton } from '@/@types/member';

const ZERO_DOLLARS = '0';

interface Data {
  calculatorButtons: CalculatorButton[];
  selectedOperator: any;
  firstNumber: string;
  secondNumber: string;
  computedValue: string;
  calculatedValue: string;
}

export default Vue.extend({
  name: 'NumberEntry',
  props: {
    initialValue: {
      type: Number,
      default: 0.0,
    },
  },
  data(): Data {
    return {
      calculatorButtons: [
        {
          value: 1,
          // @ts-ignore
          onClick: this.numberEntry,
        },
        {
          value: 2,
          // @ts-ignore
          onClick: this.numberEntry,
        },
        {
          value: 3,
          // @ts-ignore
          onClick: this.numberEntry,
        },
        {
          value: 4,
          // @ts-ignore
          onClick: this.numberEntry,
        },
        {
          value: 5,
          // @ts-ignore
          onClick: this.numberEntry,
        },
        {
          value: 6,
          // @ts-ignore
          onClick: this.numberEntry,
        },
        {
          value: 7,
          // @ts-ignore
          onClick: this.numberEntry,
        },
        {
          value: 8,
          // @ts-ignore
          onClick: this.numberEntry,
        },
        {
          value: 9,
          // @ts-ignore
          onClick: this.numberEntry,
        },
        {
          value: 'C',
          // @ts-ignore
          onClick: this.resetCalculator,
        },
        {
          value: 0,
          // @ts-ignore
          onClick: this.numberEntry,
        },
        {
          value: '<',
          // @ts-ignore
          onClick: this.removeLastNumber,
        },
        {
          value: '+',
          // @ts-ignore
          onClick: this.setOperator,
        },
        {
          value: '-',
          // @ts-ignore
          onClick: this.setOperator,
        },
        {
          value: '=',
          // @ts-ignore
          onClick: this.calculate,
        },
      ],
      selectedOperator: null,
      firstNumber: (this.initialValue * 100).toString(),
      secondNumber: ZERO_DOLLARS,
      computedValue: ZERO_DOLLARS,
      calculatedValue: ZERO_DOLLARS,
    };
  },
  methods: {
    numberEntry(value): void {
      if (!this.selectedOperator) {
        this.firstNumber = this.transformValue(this.firstNumber, value);
        this.calculatedValue = this.firstNumber;
      } else {
        this.secondNumber = this.transformValue(this.secondNumber, value);
        this.calculatedValue = this.secondNumber;
      }
    },
    transformValue(baseValue, addonValue): string {
      return baseValue + '' + addonValue;
    },
    typeButton(event): void {
      switch (event.key) {
        case '0':
          this.numberEntry(0);
          break;
        case '1':
          this.numberEntry(1);
          break;
        case '2':
          this.numberEntry(2);
          break;
        case '3':
          this.numberEntry(3);
          break;
        case '4':
          this.numberEntry(4);
          break;
        case '5':
          this.numberEntry(5);
          break;
        case '6':
          this.numberEntry(6);
          break;
        case '7':
          this.numberEntry(7);
          break;
        case '8':
          this.numberEntry(8);
          break;
        case '9':
          this.numberEntry(9);
          break;
        case '+':
          this.setOperator('+');
          break;
        case '-':
          this.setOperator('-');
          break;
        case 'Enter':
          this.calculate();
          break;
        case '=':
          this.calculate();
          break;
        case 'Backspace':
          this.removeLastNumber();
          break;
        default:
          return;
      }
    },
    setOperator(value): void {
      this.selectedOperator = value;
    },
    removeLastNumber(): void {
      if (!this.selectedOperator && this.firstNumber) {
        const newTransformation = this.transformValue(this.firstNumber, '')
        .slice(0, -1);
        if (newTransformation === '-') {
          this.firstNumber = ZERO_DOLLARS;
        } else {
          this.firstNumber = newTransformation;
        }
        this.calculatedValue = this.firstNumber;
      } else if (this.secondNumber) {
        this.secondNumber = this.secondNumber.slice(0, -1);
        this.calculatedValue = this.secondNumber;
      }
    },
    calculate(): string {
      if (this.firstNumber && this.secondNumber) {
        const firstDigit = parseFloat(this.firstNumber),
          secondDigit = parseFloat(this.secondNumber);

        switch (this.selectedOperator) {
          case '+':
            this.calculatedValue = (firstDigit + secondDigit).toString();
            break;

          case '-':
            this.calculatedValue = (firstDigit - secondDigit).toString();
            break;

          default:
            return ZERO_DOLLARS;
        }

        this.resetCalculation();
      }
    },
    resetCalculation(): void {
      this.firstNumber = this.calculatedValue;
      this.secondNumber = ZERO_DOLLARS;
      this.selectedOperator = null;
    },
    resetCalculator(): void {
      this.selectedOperator = null;
      this.firstNumber = ZERO_DOLLARS;
      this.secondNumber = ZERO_DOLLARS;
      this.calculatedValue = ZERO_DOLLARS;
    },
  },
  computed: {
    displayValue(): string {
      this.$emit('setNumber', parseInt(this.calculatedValue) / 100);
      return (parseInt(this.calculatedValue) / 100).toString();
    },
  },
});
